module.exports = __webpack_public_path__ + "static/media/HIPPA.cbfbc213.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/HIPPA.png
// module id = 2115
// module chunks = 0